module.exports = __webpack_public_path__ + "static/8-97055bc72f6543127de01c5056b0a953.jpg";